import { customScrollbar } from '../../shared';
import templates from '../templates';

const error = (() => {
    let $template = null;
    let $dialog = null;

    const _createDialog = () => {
        const options = {
            actions: ['close'],
            width: '460px',
            resizable: false,
            draggable: true,
            visible: false,
            appendTo: 'body',
            close: onClose
        };

        $dialog = $template.kendoWindow(options).data('kendoWindow');
    };

    const _reset = () => {
        if ($dialog) {
            $dialog.destroy();
        }

        $dialog = null;
    };

    const onClose = e => _reset();

    const _showDialog = options => {
        // disable animation for refreshing only
        $template = $(templates('dialog-error', options));
        $template.find('button').kendoButton();
        $template.on('submit', event => {
            event.preventDefault();
            $dialog.close();
        });

        _createDialog();

        customScrollbar($template.find('.dialog-body-upload'));

        return $dialog.center().open();
    };

    const _init = (type, message) => _showDialog({ type, message });

    return (name, type) => {
        _init(name, type);

        return $dialog;
    };
})();

export default error;



// WEBPACK FOOTER //
// ./src/scripts/core/dialog/error.js